import { 
    LOAD_TOPIC, 
    LOAD_TOPIC_SUCCESS, 
    LOAD_TOPIC_ERROR 
} from "./topic-constants";

/**
 *
 * topic reducer
 *
 */

const initialState = {
    loading: false,
    data: {},
    error: {},
};

const topicReducer = (state = initialState, action) => {

    switch (action.type) {

        case LOAD_TOPIC:
            return {
                ...state,
                loading: true,
                error: {}, 
            };
        case LOAD_TOPIC_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false, 
            };
        case LOAD_TOPIC_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false, 
            };
        default:
            return state;
    
    }

};

export default topicReducer;
